import {
  getValueFromRecursion
} from '@/utils/util'
import {
  getMenuList
} from '@/api/admin/menu'
import {
  setStorage,
  getStorage
} from '@/utils/storage'
import {
  deepClone
} from '@/utils/util'
import router from '../../router'

const state = () => ({
  fold: true, // 折叠按钮控制
  navList:getStorage({
    name: 'navList'
  }) || [],
  menuList: getStorage({
    name: 'menu'
  }) || [],
  navActive: getStorage({
    name: 'navActive'
  }) || ''
})

const getters = {
  fold: state => state.fold,
  navList: state => state.navList,
  menuList: state => state.menuList,
  navActive: state => state.navActive
}
const actions = {
  // 获取系统菜单
  getMenuList({
    commit
  }, obj) {
    return new Promise(resolve => {
      getMenuList(obj.id).then((res) => {
        const {
          data
        } = res.data
        let menuList = deepClone(data)
        commit('setMenuList', {
          menuList
        })
        resolve(menuList)
      })
    })
  }
}
const mutations = {
  foldChange(state) {
    state.fold = !state.fold
  },
  // 关闭一个tag
  closeTag(state, index) {
    let len = state.navList.length

    // 如果点击关闭的tag是当前选中的tag
    if (state.navList[index].path === state.navActive) {
      let path
      // 如果关闭的tag不是第一个，并且tag数量最少两个时，选中前一个Tag
      if (index !== 0 && len > 1) {
        path = state.navList[index - 1].path
      }
      // 如果关闭的tag是第一个并且tag数量最少两个时，选中后一个
      if (index === 0 && len > 1) {
        path = state.navList[index + 1].path
      }
      // 如果只有一个tag则去首页
      if (index === 0 && len === 1) {
        path = '/index'
      }
      this.commit('setNavActive', path)
      router.replace("/manager" + path)
    }
    state.navList.splice(index, 1)
    this.commit('setNavList', state.navList)
  },
  // 关闭多个tag
  closeMoreTag(state, {closeType, index}) {
    let path = state.navList[index].path
    if (path !== state.navActive) {
      router.replace("/manager" + path)
      this.commit('setNavActive', path)
    }
    let temp = []
    switch (closeType) {
      // 关闭左边标签
      case 0:
        temp = state.navList.filter((item,i)=>i >= index)
        break
        // 关闭右边标签
      case 1:
        temp = state.navList.filter((item,i)=>i <= index )
        break
        // 关闭其他标签
      case 2:
        temp = state.navList.filter((item,i)=>i === index )
        break
        // 关闭所有标签
      case 3:
        temp = []
        router.replace('/manager/index')
        this.commit('setNavActive', '/index')
        break
    }
    this.commit('setNavList', temp)
  },
  addTag(state, index) {
    let temp = state.navList.find(item => item != null && item.path === index)
    if (temp) {
      this.commit('setNavActive', index)
      return
    }
    let tag = getValueFromRecursion(state.menuList, 'path', index)
    if (tag) {
      state.navList.push(tag)
      this.commit('setNavList', state.navList)
      this.commit('setNavActive', index)
    }

    console.info(state.navList.length)
    if (state.navList.length > 8) {
      state.navList.shift()
    }
  },

  setNavActive(state, path) {
    state.navActive = path

    setStorage({
      name: 'navActive',
      content: path,
      type: 'session'
    })
  },
  setMenuList: (state, params = {}) => {
    let {
      menuList
    } = params;
    state.menuList = menuList
    setStorage({
      name: 'menu',
      content: menuList,
      type: 'session'
    })
  },
  setNavList(state, navList) {
    state.navList = navList
    setStorage({
      name: 'navList',
      content: navList,
      type: 'session'
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js